// data/dataCustomMapStyles.js

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerMap from '../images/markup-map-3.png';

/**
 * Configuración de icono personalizado para Leaflet
 * No requiere cambios de lógica, solo renombrar el archivo a .js
 */
export const customIcon = new L.Icon({
    iconUrl: markerMap, 
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
    iconSize: [17, 18],     // tamaño del marcador [ancho, alto]
    iconAnchor: [10, 14],   // punto del icono que corresponde a la posición del marcador
    popupAnchor: [0, -20],  // dónde aparecerá el popup relativo al icono
    shadowSize: [20, 20]
});